module.exports = __webpack_public_path__ + "static/media/img8.94c682f8.jpeg";